import React, { useState, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar1";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Lots from "./components/Lots/Manage-Lot/Lots";
import Auth from "./components/Auth/Auth";
import ForgetPassword from "./components/Auth/ForgetPassword";
import EditLot from "./components/Lots/Manage-Lot/EditLot";

import ParkingSpaceIndex from "./components/Lots/Manage-Spaces/SpaceIndex";
import APIURL from "./helper/environment";

//import Places from "./components/Map/Places";
//import HooksMap from "./components/Map/HooksMap";
//import EditLot from "./components/Lots/Manage-Lot/EditLot"; // Import the EditLot component
import ParkingMap from "./components/Map/ParkingMap";

import BuyButtonComponent from "./components/Lots/Manage-Lot/BuyButtonComponent";

import ReservationTimePicker from "./components/Calendar/ReservationTimePicker";

import Filter from "./components/Calendar/Filter";
// import Places from "./components/Map/Places";

import Places from "./components/Map/Places";

import Index from "./components/Pages/Index";
import Signup from "./components/Auth/Signup";

import SearchBar from "./components/Map/SearchBar";

//import Findplace from "./components/Map/Findplace";

//import ContactUs from "./components/Pages/Contact_Us";
//import ReservationTimePicker from "./components/Calendar/ReservationTimePicker";

function App() {
  // useState variables
  const [token, setToken] = useState("");
  const [parkingLots, setParkingLots] = useState([]);
  const navigate = useNavigate();

  // useEffect to update token from local storage
  useEffect(() => {
    // If we have something in our local storage then let's update our State Variable so other components can use it.
    if (localStorage.getItem("token")) {
      setToken(localStorage.getItem("token"));
    }
  }, []);

  function updateToken(newToken) {
    // update the state of token
    setToken(newToken);
    // update the localStorage with the new token
    localStorage.setItem("token", newToken);
  }

  function clearToken() {
    // Clear local storage
    localStorage.clear();
    // Set the token to be blank
    setToken("");
    // Navigate to the "/"
    navigate("/");
  }

  async function getAllLots() {
    let url = `${APIURL}/parking-lot/display-all`;

    let myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    const requestOptions = {
      headers: myHeaders,
      method: "GET",
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      setParkingLots(data.parkingLots);
    } catch (error) {
      console.error(error.message);
    }
  }

  return (
    <div>
      <div>
        <Navbar token={token} clearToken={clearToken} />
      </div>

      {/* <Index /> */}
      {/* <ContactUs /> */}
      {/* <ReservationTimePicker /> */}

      {/* <Filter /> */}

      <Routes>
        <Route
          exact
          path="/"
          element={
            <div>
              <Header token={token} clearToken={clearToken} />
            </div>
          }
        />
        <Route
          exact
          path="/Auth"
          element={<Auth updateToken={updateToken} />}
        />
        <Route
          exact
          path="/Signup"
          element={<Signup updateToken={updateToken} />}
        />
        <Route path="/parking-lot/edit/:id" element={<EditLot />} />
        <Route
          exact
          path="/Map"
          element={
            <ParkingMap
              updateToken={updateToken}
              parkingLots={parkingLots}
              getAllLots={getAllLots}
            />
          }
        />
        <Route
          exact
          path="/Places"
          element={
            <div>
              <Places token={token} clearToken={clearToken} />
            </div>
          }
        />

        <Route
          exact
          path="/Lots"
          element={
            <Lots
              token={token}
              clearToken={clearToken}
              navigate={navigate}
              parkingLots={parkingLots}
              getAllLots={getAllLots}
            />
          }
        />
        <Route
          exact
          path="/ParkingSpaces/:parkingLot_id"
          element={
            <ParkingSpaceIndex
              token={token}
              clearToken={clearToken}
              parkingLots={parkingLots}
              getAllLots={getAllLots}
            />
          }
        />
        <Route
          exact
          path="/Calendar"
          element={
            <div>
              <ReservationTimePicker token={token} clearToken={clearToken} />
            </div>
          }
        />
        <Route
          exact
          path="/ForgetPassword"
          element={
            <div>
              <ForgetPassword token={token} clearToken={clearToken} />
            </div>
          }
        />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
